import CurrenciesSelect from './CurrenciesSelect';

export default CurrenciesSelect;
